<template>
  <div>
    <div class="mod">
      <div v-if="isPay0" class="pay-area">
        <a href="javascript:;" class="btn-submit" @click="payByCode"
          >确定支付</a
        >
      </div>
      <div v-else class="pay-area">
        <div class="ewm">
          <a href="javascript:;" @click="payModal">立即充值</a>
        </div>
      </div>
    </div>
    <div v-show="showPayDialog" class="pay-modal">
      <div class="pay-modal-masking"></div>
      <div class="pay-dialog">
        <div class="pay-dialog-body">
          <div class="pay-dialog-content">
            <a
              href="javascript:;"
              class="pay-dialog-close"
              @click="closePayModal"
            ></a>
            <p class="account-money">
              交易金额：<span class="account">{{ realRmb / 100 }}</span
              >元
            </p>
            <div v-if="showQrCode" class="pay-qrcode">
              <img v-if="qrImg" :src="qrImg" />
              <!--  payStatus==3 订单支付中  -->
              <div v-if="payStatus === 3" class="pay-status">
                <p>订单支付中</p>
              </div>
              <div class="info">
                <p class="ico">
                  <img src="~/assets/img/recharge/pay-ico.png" />
                </p>
                <p class="tips-txt">使用微信或支付宝扫码支付</p>
              </div>
            </div>
            <div v-else class="invalid-tip">
              <img src="~/assets/img/recharge/qrcode-fail.png" />
              <span class="invalid-tip-text">二维码已失效</span>
              <a href="javascript:;" class="refresh-code" @click="refreshQrCode"
                >点击刷新二维码</a
              >
            </div>
            <div class="pay-tips">适度娱乐 理性消费</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// TODO: 二维码结果查询
import { mapGetters, mapState } from 'vuex'
import { qrCode } from '~/services/pay'
export default {
  inject: ['toggleCert', 'isAdult'],
  data() {
    return {
      game_orderid: '',
      deliver_userid: '',
      showPayDialog: false,
      showQrCode: true,
      payStatus: 0,
      invalidTime: 0
    }
  },
  computed: {
    ...mapState('recharge', ['inputAcc', 'errTip', 'qrImg', 'curCouponItem']),
    ...mapGetters('recharge', [
      'ext2',
      'rmb',
      'curRole',
      'realRmb',
      'isPay0',
      'isNeedGameRole'
    ]),
    updateQR() {
      return {
        flag:
          this.inputAcc &&
          this.curRole.role_name &&
          this.realRmb > 0 &&
          !this.isPay0,
        inputAcc: this.inputAcc,
        roleName: this.curRole.role_name,
        realRmb: this.realRmb,
        couponCode: this.curCouponItem.code
      }
    }
  },
  watch: {
    updateQR: {
      immediate: true,
      handler(val, oldVal) {
        this.timer && clearTimeout(this.timer)
        if (val && val.flag) {
          this.$store.commit('recharge/setQrImg', null)
        }

        // if (val && val.flag) {
        //   if (
        //     val.couponCode !== oldVal.couponCode ||
        //     !val.couponCode ||
        //     !this.qrImg
        //   ) {
        //     this.getQrCode()
        //   }
        // } else {
        //   this.$store.commit('recharge/setQrImg', null)
        // }
      }
    },
    errTip(val) {
      if (val) {
        this.timer && clearTimeout(this.timer)
        this.$store.commit('recharge/setQrImg', null)
      }
    },
    payStatus(cur, pre) {
      if (cur === 2 && pre === 3) {
        this.$nextTick(() => {
          this.payStatus = 3
        })
      }
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    getQrCode(flag = false) {
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      if (flag) {
        const ext2 = this.ext2
        this.$xlaPush('charge_page_pay_submit', {
          pay_type: 'scan_qrcode',
          game_id: ext2.game_id,
          channel: ext2.server_id,
          account: ext2.deliver_userid,
          amount: this.realRmb / 100,
          coupon: 0,
          default: 10
        })
      }
      this.innerGetQrCode()
    },
    innerGetQrCode() {
      this.payOrder().then((data) => {
        const postExt2 = {
          ...this.ext2,
          game_order_id: data.game_order_id,
          xl_price: this.rmb,
          runtime: this.$util.getRunTime()
        }
        // (rechargeType === 1) ===> 判断是否为原始传奇内嵌充值页
        if (this.$store.getters['app/hideRechargeType'] === 1) {
          const query = this.$route.query
          postExt2.game_ext = JSON.stringify({
            uid: query.uid,
            server_id: query.sid,
            product_name: query.product_name,
            product_id: query.product_id,
            money: query.money,
            game_role_id: query.game_role_id || '',
            game_id: query.game_id,
            extra: query.extra || ''
          })
        }
        qrCode({
          rmb: this.rmb,
          ext2: postExt2
        })
          .then((data) => {
            this.$store.commit('recharge/setErrTip', null)
            this.$store.commit('recharge/setQrImg', data)
            this.checkOrder()
          })
          .catch(() => {
            this.$store.commit('recharge/setQrImg', null)
            this.$store.commit('recharge/setErrTip', '二维码生成失败')
          })
      })
    },
    checkOrder() {
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.invalidTime += 1
        if (this.invalidTime === 7200) {
          if (this.payStatus !== 1 && this.payStatus !== 3) {
            this.showQrCode = false
            clearTimeout(this.timer)
            this.invalidTime = 0
            return
          }
        }
        this.$request('checkOrder', {
          body: {
            game_order_id: this.game_orderid,
            deliver_userid: this.deliver_userid
          }
        })
          .then((data = {}) => {
            // payStatus==1 订单支付成功  payStatus==3 订单支付中
            this.payStatus = Number(data.status)
            if (this.payStatus === 1) {
              this.showPayDialog = false
              this.$notify({
                type: 'success',
                title: '支付成功',
                btnTxt: '确定',
                message: '请到游戏内查收,如有问题请及时联系客服',
                duration: 0
              })
              this.$store.commit('recharge/setPayStatus', true)
              this.$store.commit('recharge/choiceCoupon', [-1])
              this.$store.dispatch('recharge/getCoupons')
              // this.getQrCode()
            }
            if (this.payStatus === 2) {
              this.checkOrder()
            } else if (this.payStatus === 3) {
              this.checkOrder()
            }
          })
          .catch(() => {
            this.checkOrder()
          })
      }, 1000)
    },
    payOrder() {
      return this.$request('payOrder', {
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          ...this.ext2,
          num: 1,
          rmb: this.rmb
        }
      })
        .then((data = {}) => {
          this.game_orderid = data.game_order_id
          this.deliver_userid = data.deliver_userid
          return data
        })
        .catch((err) => {
          // this.$notify(err.message)
          if (err.message === '获取接口参数出错') {
            this.$notify({
              message: '请选择充值金额'
            })
          } else {
            this.$notify(err.message)
          }
          this.$store.commit('recharge/setQrImg', null)
          this.timer && clearTimeout(this.timer)
        })
    },
    async payByCode() {
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      // 直购校验账户是否当前登录的账户
      if (this.$store.getters['app/hideRechargeType'] === 1) {
        const result = await this.$store.dispatch('recharge/convertToUserId')
        if (!result.status) {
          this.$notify({
            message: result.msg
          })
          return
        }
      }
      const isNotCurRoleName = this.isNeedGameRole && !this.ext2.role_name
      if (isNotCurRoleName) {
        return this.$notify({
          message: '请选择游戏角色',
          duration: -1
        })
      }
      return this.payOrder()
        .then((data) => {
          this.$request(
            'couponPay',
            {
              body: {
                ...this.ext2,
                rmb: this.rmb,
                pay_type: 'coupon_order',
                num: 1,
                game_order_id: data.game_order_id
              }
            },
            { showNotify: true }
          ).then((data = {}) => {
            if (data.status) {
              this.$store.commit('recharge/setPayStatus', true)
              this.$store.commit('recharge/choiceCoupon', [-1])
              this.$store.dispatch('recharge/getCoupons')
            }
          })
        })
        .catch((err) => this.$notify(err.message))
    },
    async payModal() {
      if (!this.$store.getters.isLogin) {
        return this.$store.commit('app/setLoginPop', true)
      }
      // 直购校验账户是否当前登录的账户
      if (this.$store.getters['app/hideRechargeType'] === 1) {
        const result = await this.$store.dispatch('recharge/convertToUserId')
        if (!result.status) {
          this.$notify({
            message: result.msg
          })
          return
        }
      }
      const isNotCurRoleName = this.isNeedGameRole && !this.ext2.role_name
      if (isNotCurRoleName) {
        return this.$notify({
          message: '请选择要充值的游戏/区服/角色',
          duration: -1
        })
      }
      const succfn = () => {
        this.payOrder().then((data) => {
          if (data != null) {
            this.showQrCode = true
            this.showPayDialog = true
            const postExt2 = {
              ...this.ext2,
              game_order_id: data.game_order_id,
              xl_price: this.rmb,
              runtime: this.$util.getRunTime()
            }
            // (rechargeType === 1) ===> 判断是否为原始传奇内嵌充值页
            if (this.$store.getters['app/hideRechargeType'] === 1) {
              const query = this.$route.query
              postExt2.game_ext = JSON.stringify({
                uid: query.uid,
                server_id: query.sid,
                product_name: query.product_name,
                product_id: query.product_id,
                money: query.money,
                game_role_id: query.game_role_id || '',
                game_id: query.game_id,
                extra: query.extra || ''
              })
            }
            qrCode({
              rmb: this.rmb,
              ext2: postExt2
            })
              .then((data) => {
                this.$store.commit('recharge/setErrTip', null)
                this.$store.commit('recharge/setQrImg', data)
                this.checkOrder()
              })
              .catch(() => {
                this.$store.commit('recharge/setQrImg', null)
                this.$store.commit('recharge/setErrTip', '二维码生成失败')
              })
          }
        })
      }
      this.$util.realNameAuth('pay', 'default', succfn)
    },
    refreshQrCode() {
      this.showQrCode = true
      this.getQrCode()
    },
    closePayModal() {
      clearTimeout(this.timer)
      this.showPayDialog = false
      this.showQrCode = true
      this.payStatus = 0
    }
  }
}
</script>
